<template>
  <div class="carousel-layout">
    <div :class="['background', $store.state.config.medals.background]">
      <!-- <PictoKunai class="background__kunai" />
      <PictoStar class="background__star background__star--left" />
      <PictoStar class="background__star background__star--right" />
      <PictoSpiral class="background__spiral" /> -->
    </div>

    <div class="items">
      <ul
        class="items__wrapper"
        :style="`transform: translate3d(${translateX}, 0, 0)`"
      >
        <CarouselItem
          v-for="(item, index) in items"
          :key="`carousel-item-${index}`"
          class="carousel-item"
          :active="currentSlide === index"
          :style="`z-index: ${currentSlide === index ? 0 : 1}`"
          :flipped="flipped && currentSlide === index"
          :product="item"
          @click.native="$event => { if(currentSlide === index) flipped = !flipped }"
        />
      </ul>
    </div>

    <div class="ui__pagination">
      {{ currentSlide + 1 }}/{{ items.length }}
    </div>

    <div
      v-show="currentSlide > 0"
      class="ui__left picto-navigation-carousel"
      @click="currentSlide--"
    />

    <div
      v-show="currentSlide < items.length - 1"
      class="ui__right picto-navigation-carousel"
      @click="currentSlide++"
    />

    <div
      class="ui__flip picto-reverse-coin"
      @click="flipped = !flipped"
    />

    <Transition name="fade-mention">
      <div
        v-show="shouldShowMention"
        class="limited decoration-carousel-minimedaille-kyubi"
      >
        <span class="limited__content">{{ $store.state.config.medals.mention }}</span>
      </div>
    </Transition>
  </div>
</template>

<script>
// import PictoKunai from '@/components/pictos/PictoKunai.vue';
// import PictoStar from '@/components/pictos/PictoStar.vue';
// import PictoSpiral from '@/components/pictos/PictoSpiral.vue';
import CarouselItem from './Item.vue';

export default {
  name: 'CarouselLayout',

  components: {
    CarouselItem,
    // PictoKunai,
    // PictoStar,
    // PictoSpiral,
  },

  data() {
    return {
      currentSlide: 0,
      flipped: false,
      cssVars: {
        gapSize: 0,
        itemSize: 0,
      },
    };
  },

  computed: {
    items() {
      return this.$store.state.config.medals.items;
    },

    translateX() {
      const gapSize = this.$data.cssVars.gapSize;
      const itemSize = this.$data.cssVars.itemSize;
      return `${this.$data.currentSlide * -(itemSize + gapSize)}px`;
    },

    shouldShowMention() {
      const currentItem = this.items[this.$data.currentSlide];
      return typeof currentItem.mention === 'boolean' && currentItem.mention === true;
    },
  },

  watch: {
    currentSlide() {
      this.$data.flipped = false;
    },
  },

  mounted() {
    window.addEventListener('resize', this.updateCSSVars);
    this.updateCSSVars();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateCSSVars);
  },

  methods: {
    updateCSSVars() {
      const computedStyle = getComputedStyle(document.querySelector(':root'));
      this.$data.cssVars.gapSize = parseFloat(computedStyle.getPropertyValue('--carousel-gap'));
      this.$data.cssVars.itemSize = parseFloat(computedStyle.getPropertyValue('--carousel-item-width'));
    },
  },
};
</script>

<style lang="stylus">
  :root {
    --carousel-gap: 100px;
    --carousel-item-width: 300px;

    +desktop() {
      --carousel-item-width: 408px;
    }
  }
</style>

<style lang="stylus" scoped>
  .carousel-layout {
    position: relative;
  }

  .carousel-item {
    width: var(--carousel-item-width);
    transition: transform 0.25s;
    transform: translateX(-50%);
  }

  .background,
  .ui {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: calc(100% - 40px);

    +desktop() { height: 100%; }
  }

  .background {
    z-index: 0;
    border: 2px solid black;
    border-radius: 30px;
    overflow: hidden;
    background-repeat: repeat;

    &__kunai {
      position: absolute;
      display: none;
      +desktop() {
        display: block;
        top: 105px;
        left: 50%;
        transform: translateX(-525px) rotate(20deg) scale(1.85);
      }
    }

    &__star {
      position: absolute;
    }

    &__star--left {
      top: 360px;
      left: 50%;
      transform: translateX(-160px) scale(0.75) rotate(45deg);
      +desktop() {
        top: 450px;
        transform: translateX(-430px) scale(0.75) rotate(45deg);
      }
    }

    &__star--right {
      top: 65px;
      right: 50%;
      transform: translateX(550px);
    }

    &__spiral {
      position: absolute;
      top: 350px;
      right: 50%;
      transform: translateX(120px);
      +desktop() {
        top: 470px;
        transform: translateX(420px);
      }
    }
  }

  .ui {
    &__pagination {
      @extends $txt-carousel-pagination;
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 100;

      padding: 8px 11px;
      border-radius: 30px;
      border: 2px solid black;
      background: white;
    }

    &__left,
    &__right,
    &__flip {
      position: absolute;
      bottom: 50px;
      cursor: pointer;

      +desktop() {
        top: 50%;
        bottom: auto;
      }
    }

    &__left,
    &__right {
      @extends $button-blue-round;
    }

    &__left {
      z-index: 101;
      right: 50%;
      transform: translate(-60px, 0);
      +desktop() { transform: translate(-270px, 0); }
    }

    &__right {
      z-index: 102;
      left: 50%;
      transform: translate(60px, 0) rotate(180deg);
      +desktop() { transform: translate(270px, 0) rotate(180deg); }
    }

    &__flip {
      z-index: 103;
      background-size: 100%;
      width: 60px;
      height: @width;
      left: 50%;
      transform: translate(-50%, 0);

      +desktop() {
        width: 40px;
        height: @width;
        transform: translate(125px, 125px);
      }
    }
  }

  .items {
    position: relative;
    z-index: 1;

    overflow: hidden;

    padding: 40px 0 0 50%;
    border: 2px solid transparent;

    +desktop() {
      padding: 50px 0 0 50%;
    }
  }

  .items__wrapper {
    display: flex;
    gap: var(--carousel-gap);
    transition: transform 0.5s ease-in-out;
  }

  .limited {
    position: absolute;
    z-index: 105;
    top: 70px;
    left: 50%;

    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateX(60px) scale((84/134));

    +desktop() {
      transform: translateX(295px);
      top: auto;
      bottom: 20px;
    }

    &.fade-mention-enter-active,
    &.fade-mention-leave-active { transition: opacity 0.35s ease-in-out; }

    &.fade-mention-enter,
    &.fade-mention-leave-to { opacity: 0; }
  }

  .limited__content {
    @extends $txt-carousel-mention;
    color: white;
    white-space: break-spaces;
    text-align: center;
    transform: skewX(-10deg);
  }
</style>
